/*
 * Created By sswaminathan
 * Created on Sat Sep 11 2021
 * Created on CommonDrawer.js
 * Copyright (c) 2021  ©Palo Alto Networks
 */

/**
 * CommonDrawer is common component build as a work arund for the
 * Drawer component of PANWDS. It takes the height and width and color
 * as input parameter.
 */

import styled from 'styled-components'
import { getFrameworkVar } from '@sparky/framework'
import { FF_USE_NEW_LEFT_NAV } from '../../utils/FeatureFlags'
import { useOnOutsideClick } from '@panwds/react-ui'
import { useRef } from 'react'


export const DrawerWrapper = styled.div`
    position: absolute;
    margin-top:10px;
    margin-left: 4px;
    border-radius: 4px;
    background-color: ${props => (props.color ? props.color : 'rgb(25, 34, 46)')};  ;
    width: 320px;
    min-width: 320px;
    height: ${props => (props.height ? 'auto' : '98%')};
    overflow: hidden;
    margin-bottom: 10px;
    & -visible {
      visibility: visible;
    }
    & -hide {
      width: 0;
      visibility: collapse;
    }`

const CommonDrawer = ({ isOpen, color, width, height, children, onClose, isSideNavCollapsed }) => {
  const useNewLeftNav = getFrameworkVar(FF_USE_NEW_LEFT_NAV)
  const className = `cloud-mgm-drawer panwds-unset-reboot panwds-tw2 tw-transition-all tw-duration-300 tw-ease-in-out ${isOpen ? '-visible tw-h-full' : '-hide'} ${useNewLeftNav && (isSideNavCollapsed ? '-collapsed' : '-expanded')}`
  const drawerRef = useRef(null)
  useOnOutsideClick(drawerRef, () => {
    if (drawerRef.current && isOpen) {
      setTimeout(onClose, 200)
    }
  })

  return (
    <div ref={useNewLeftNav ? drawerRef : undefined} className={className}>
      <div onClick={onClose} className={'tw-bg-blue-steel-900 tw-opacity-30 tw-w-full tw-h-full'} />
      <DrawerWrapper isOpen={isOpen} className='tw-flex tw-flex-col tw-flex-shrink tw-min-h-0' color={color} width={width} height={height}>
        {children}
      </DrawerWrapper>
    </div>
  )
}
export default CommonDrawer
